import { colorClass, ballClass } from "./BetSheet";
import { money } from "../../lib/api";

const numClass = r => `rt-num g${r.result_number}`;

export function ResultsTable({ results }) {
  return (
    <div className="result-table" data-testid="results-table">
      <div className="rt-row rt-head"><span>Period</span><span>Number</span><span>Big Small</span><span>Color</span></div>
      {results.map(r => <div className="rt-row" key={r.period_id} data-testid={`result-${r.period_id}`}><span>{r.period_id}</span><span className={numClass(r)}>{r.result_number}</span><span>{r.result_size}</span><span>{r.result_colors.map(c => <i key={c} className={`dot ${colorClass(c)}`} />)}</span></div>)}
      {!results.length && <div className="empty">Results appear after the first round</div>}
    </div>
  );
}

export function ChartTable({ results }) {
  return (
    <div className="result-table chart" data-testid="chart-table">
      <div className="rt-row rt-head"><span>Period</span><span>Number</span></div>
      {results.map(r => <div className="rt-row" key={r.period_id}><span>{r.period_id.slice(-6)}</span>
        <span className="chart-balls">{[...Array(10).keys()].map(n => <i key={n} className={n === r.result_number ? `hit g${n}` : ""}>{n}</i>)}<b className={`sz ${r.result_size}`}>{r.result_size[0]}</b></span></div>)}
      {!results.length && <div className="empty">No data yet</div>}
    </div>
  );
}

export function MyBets({ bets }) {
  return <div className="history-list" data-testid="my-bets-list">{bets.length ? bets.map(b => (
    <div className="transaction" key={b.bet_id}><div className={`mybet-icon ${b.selection_type === "number" ? ballClass(b.selection) : colorClass(b.selection)}`}><span>{b.selection_type === "number" ? b.selection : b.selection[0]}</span></div>
      <div><b>{b.period_id}</b><small>{b.selection_type === "number" ? `Number ${b.selection}` : b.selection} · {money(b.amount)}</small></div>
      <strong className={b.status === "won" ? "green" : b.status === "lost" ? "red" : ""}>{b.status === "won" ? `+${money(b.payout)}` : b.status === "lost" ? `-${money(b.amount)}` : "Pending"}<small>{b.status === "pending" ? "Waiting" : b.status === "won" ? "Succeed" : "Failed"}</small></strong></div>)) : <div className="empty">No bets yet</div>}</div>;
}

export function Rules({ onClose }) {
  return (
    <div className="sheet-backdrop center" onClick={onClose} data-testid="how-to-play-modal">
      <div className="rules-card" onClick={e => e.stopPropagation()}>
        <h3>How to play</h3>
        <ul><li>Pick Green, Violet, Red, a number 0–9, or Big / Small before the timer hits the last 5 seconds.</li>
          <li>Green: 1,3,7,9 pay 2X · 5 pays 1.5X</li><li>Red: 2,4,6,8 pay 2X · 0 pays 1.5X</li><li>Violet: 0 or 5 pays 4.5X</li>
          <li>Number: exact match pays 9X</li><li>Big (5–9) / Small (0–4) pays 2X</li><li>Every bet counts toward your bonus wagering.</li></ul>
        <button className="primary-button" onClick={onClose} data-testid="close-rules-button">Close</button>
      </div>
    </div>
  );
}
